"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeTree = void 0;
var getNodeCenterY_1 = require("./getNodeCenterY");
var getNodeCenterX_1 = require("./getNodeCenterX");
var getFromMap_1 = require("./getFromMap");
var last_1 = require("./last");
var normalizeTree = function (root, accessor, settings, map) {
    var targets = getFromMap_1.getFromMap(root[accessor], map);
    if (!targets || !targets.length)
        return;
    var firstTargetNextBefore = getFromMap_1.getFromMap(targets[0][settings.nextBeforeAccessor], map);
    var firstMostNode = (firstTargetNextBefore === null || firstTargetNextBefore === void 0 ? void 0 : firstTargetNextBefore[0]) || targets[0];
    var lastTarget = last_1.last(targets);
    var lastTargetNextAfter = last_1.last(getFromMap_1.getFromMap(lastTarget[settings.nextAfterAccessor], map));
    var lastMostNode = lastTargetNextAfter || lastTarget;
    var shift;
    if (settings.orientation === "vertical") {
        if (settings.groupTargetsByNextAfters) {
            var groups = targets.reduce(function (groups, target, index) {
                if (!target.virtualSourceId) {
                    groups[root[settings.idAccessor]] =
                        groups[root[settings.idAccessor]] || [];
                    groups[root[settings.idAccessor]].push(target);
                }
                else {
                    if (!targets[index - 1] ||
                        target.virtualSourceId !== targets[index - 1].virtualSourceId) {
                        groups[target.virtualSourceId] = [target];
                    }
                    else {
                        groups[target.virtualSourceId].push(target);
                    }
                }
                return groups;
            }, {});
            console.log({ groups: groups });
            var centerPointX = Object.values(groups).reduce(function (acc, group) {
                acc += (group[0].x + last_1.last(group).x + last_1.last(group).width) / 2;
                return acc;
            }, 0) / Object.keys(groups).length;
            var virtualCenterPointX = Object.keys(groups).reduce(function (acc, virtualSourceId) {
                acc += getNodeCenterX_1.getNodeCenterX(map[virtualSourceId]);
                return acc;
            }, 0) / Object.keys(groups).length;
            shift = centerPointX - virtualCenterPointX;
        }
        else {
            var centerPointX = (firstMostNode.x + lastMostNode.x + lastMostNode.width) / 2;
            shift = centerPointX - getNodeCenterX_1.getNodeCenterX(root);
        }
        targets.forEach(function (target) {
            normalizeTargetsX(target);
        });
    }
    else {
        var centerPointY = (firstMostNode.y + lastMostNode.y + lastMostNode.height) / 2;
        shift = centerPointY - getNodeCenterY_1.getNodeCenterY(root);
        targets.forEach(function (target) {
            normalizeTargetsY(target);
        });
    }
    function normalizeTargetsX(subtree) {
        var _a, _b, _c;
        subtree.x -= shift;
        (_a = getFromMap_1.getFromMap(subtree[settings.nextBeforeAccessor], map)) === null || _a === void 0 ? void 0 : _a.forEach(function (nextBefore) {
            nextBefore.x -= shift;
        });
        (_b = getFromMap_1.getFromMap(subtree[settings.nextAfterAccessor], map)) === null || _b === void 0 ? void 0 : _b.forEach(function (nextAfter) {
            nextAfter.x -= shift;
        });
        (_c = getFromMap_1.getFromMap(subtree[accessor], map)) === null || _c === void 0 ? void 0 : _c.forEach(function (node) {
            normalizeTargetsX(node);
        });
    }
    function normalizeTargetsY(subtree) {
        var _a, _b, _c;
        subtree.y -= shift;
        (_a = getFromMap_1.getFromMap(subtree[settings.nextBeforeAccessor], map)) === null || _a === void 0 ? void 0 : _a.forEach(function (nextBefore) {
            nextBefore.y -= shift;
        });
        (_b = getFromMap_1.getFromMap(subtree[settings.nextAfterAccessor], map)) === null || _b === void 0 ? void 0 : _b.forEach(function (nextAfter) {
            nextAfter.y -= shift;
        });
        (_c = getFromMap_1.getFromMap(subtree[accessor], map)) === null || _c === void 0 ? void 0 : _c.forEach(function (node) {
            normalizeTargetsY(node);
        });
    }
};
exports.normalizeTree = normalizeTree;
//# sourceMappingURL=normalizeTree.js.map